import { render, staticRenderFns } from "./ColorControls.vue?vue&type=template&id=16872d73&"
import script from "./ColorControls.vue?vue&type=script&lang=ts&"
export * from "./ColorControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports